import React from "react";
import { ToggleButton, ToggleButtonGroup } from "react-aria-components";
import { getConfigValue } from "../api/price";
import { useOfferCalculatorDispatch, useOfferCalculatorState } from "../context/OfferCalculatorContext";
import { getEnabledOptions } from "../utils/configHelpers";
export default function FinancingTypeSegment() {
    const state = useOfferCalculatorState();
    const dispatch = useOfferCalculatorDispatch();
    const field = getConfigValue(state.config, "finance_type");
    const options = getEnabledOptions(field);
    if (!options.length) {
        return null;
    }
    return (<div className="config-group group-finance_type">
      <div className="mb-4 text-base font-medium leading-5">Forma finansowania</div>
      <ToggleButtonGroup selectionMode="single" selectedKeys={state.finance_type ? new Set([state.finance_type]) : new Set()} onSelectionChange={(keys) => {
            const value = Array.from(keys)[0];
            if (value) {
                dispatch({ type: "set_param", name: "finance_type", value: String(value) });
            }
        }} className="notranslate flex rounded-xl border border-[#DDE2E4] bg-[#F7F8FA]">
        {options.map((option) => (<ToggleButton key={option.key} id={option.key} className={({ isSelected }) => `flex flex-1 items-center justify-center gap-1 rounded-lg px-4 text-sm font-normal leading-[1.8rem] outline-none transition focus-visible:ring-2 focus-visible:ring-[#0071CE] h-10 min-h-10 ${isSelected ? "bg-[#0071CE] text-white" : "text-[#1C2022]"}`}>
            {option.label}
          </ToggleButton>))}
      </ToggleButtonGroup>
    </div>);
}
